export const STATE_NAME = "new-user";
export const FORM_NAME = "new-user";
export const SELF_SIGNER_VIEW_NAME = "SELF_SIGNER_VIEW_NAME";
export const OTHER_SIGNER_VIEW_NAME = "OTHER_SIGNER_VIEW_NAME";
export const SIGNER_VIEW_NAME = "SIGNER_VIEW_NAME";
